import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${props => props.theme.colors.white};
  margin-top: ${pxToRem('40px')};
  padding: ${pxToRem('24px')};
  border-radius: ${pxToRem('8px')};
  border: solid ${pxToRem('1px')} #ececed;
`;

export const DetailsTitle = styled.div``;

export const DetailsDataContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);

  @media ${props => props.theme.device.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`;
export const DetaildDataItem = styled.div`
  flex: 1 0 20%;
  min-width: ${pxToRem('205px')};
`;
export const ItemTitle = styled.div`
  margin: ${pxToRem('24px')} 0 ${pxToRem('8px')} 0;
  color: ${props => props.theme.colors.grayText};
`;
export const Item = styled.div``;

export const ContentWrapper = styled.div``;

export const NotAvailable = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.white};
  margin-top: ${pxToRem('40px')};
  padding: ${pxToRem('24px')};
  border-radius: ${pxToRem('8px')};
  border: solid ${pxToRem('1px')} #ececed;
  align-items: center;
  justify-content: center;
`;
